import { useEffect, useState } from 'react';
import getConfig from 'next/config';

import { HotelFavoriteLink } from './HotelFavoriteLink';

type HotelSearchProps = {
    isLoggedIn?: boolean;
};

const {
    publicRuntimeConfig: { hotelFavoritesUrl },
} = getConfig();

export const AdditionalHotelContent = ({ isLoggedIn }: HotelSearchProps) => {
    const [favoriteHotelCount, setFavoriteHotelCount] = useState(0);

    useEffect(() => {
        if (isLoggedIn && hotelFavoritesUrl) {
            fetch(hotelFavoritesUrl, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                },
            })
                .then((response) => response.json())
                .then((data) => setFavoriteHotelCount(~~data))
                .catch();
        }
    }, [isLoggedIn, hotelFavoritesUrl]);

    return favoriteHotelCount > 0 ? <HotelFavoriteLink favoriteHotelCount={favoriteHotelCount} /> : null;
};
